import React, { useState, useEffect, Fragment } from 'react';
import {
    Card,
    CardBody,
    CardImg,
    ButtonGroup,
    Button,
    Row,
    Modal,
    ModalHeader,
    CustomInput,
    InputGroupAddon,
    InputGroupText,
    Input,
    ModalBody,
    InputGroup
} from 'reactstrap';
import { ChromePicker } from 'react-color'
import {
    Separator,
    Colxx,
} from '../../../../../../components/common/CustomBootstrap';

import {
    SelectStyle,
    InputStlye,
    setBackGroundColor,
} from '../../style/DigitalAssistantStyle';

import avatars from '../../data/avatarData';
import ImageGallery from '../../../propinfo/gallery/index';
import { getGroupID } from '../../../../../../helpers/AxiosAPI';
import { string } from 'prop-types';
import { FontAwesome } from '@fortawesome/react-fontawesome';
import FontsList from '../FontsList';
export default function StandaloneDigitalAssistant({
    botSettings,
    saveIntegration,
    integrationId,
}) {
    /** Avatar state */
    const [isSelected, setIsSelected] = useState({
        Jenni: false,
        Novi: false,
        Bob: false,
        Sarah: false,
        Wallis: false,
    });
    const [isFooterHide, setIsFooterHide] = useState(botSettings.isFooterHide !== undefined ? botSettings.isFooterHide : false);
    const [avatarLink, setAvatarLink] = useState('');
    const [avatarName, setAvatarName] = useState('');
    const [subTitle, setSubTitle] = useState('');
    const [arrowType, setArrowType] = useState(0);
    const [arrowSize, setArrowSize] = useState(40);
    const [font, setFont] = useState('');
    const [arrow, setArrow] = useState('');
    const [displayServices, setDisplayServices] = useState('');
    const [galleryVisible, setGalleryVisible] = useState(false);
    /** other Digital Assistant state */
    const [edit, setEdit] = useState(true);
    let [setting, setSetting] = useState(botSettings);
    const [error, setError] = useState(true);
    const [fontsList, setFontsList] = useState({
        'title': '',
        'subTitle': '',
        'serviceTitle': '',
        'serviceDescription': '',
        'website': '',
        'buttonText': '',
        'voucherTitle': '',
        'voucherDescription': '',
    });
    let [iseditMode, setEditMode] = useState({
        'title': false,
        'subTitle': false,
        'arrow': false,
        'primaryColor': false,
        'buttonColor': false,
        'redeemBar': false,
        'redeemButton': false,
        'buttonTextColor': false,
        'redeemTextColor': false,
        'shoppingBar': false,
        'shoppingBarText': false,
    });
    useEffect(() => {
        if (botSettings) {
            setSetting(botSettings);
            setAvatarName(botSettings.title);
            setSubTitle(botSettings.subTitle);
            setAvatarLink(botSettings.icon);
            setFont(botSettings.font);
            setArrowType(botSettings.arrowType);
            setArrowSize(botSettings.arrowSize);
            setDisplayServices(botSettings.displayServices);
            setFontsList(botSettings.fonts);
            setIsSelected({ ...avatars, [botSettings.name]: true });
        }
    }, [botSettings]);

    useEffect(() => {
        if (setting) {
            setSetting({
                ...setting,
                urls: { ...setting.urls, icon: avatarLink },
            });
        }
    }, [avatarLink]);
    const RedirectToDemo = () => {
        var url = `${process.env.REACT_APP_BOT_DEMO
            }?gid=${getGroupID()}&iid=${integrationId}`;
        window.open(url, '_blank');
    };

    const handleColoursReset = () => {
        let colours = {
            title: 'black',
            'subtitle': 'black',
            primaryColor: '#E31B78',
            buttonColor: '#033DA5',
            redeemBar: '#FA8DAB',
            redeemButton: '#F5D2E3',
            buttonTextColor: 'white',
            redeemTextColor: 'black',
            shoppingBar: '#ED187B',
            shoppingBarText: 'white'
        };
        setSetting({ ...setting, colours: colours });
    }


    const handleChange = (e) => {
        const value = e.target.value;
        setSetting({
            ...setting,
            [e.target.name]: value,
        });
    };

    const handleSave = () => {
        setEdit(!edit);
        setting.isFooterHide = isFooterHide == "true" ? true : false;
        setting.title = avatarName;
        setting.icon = avatarLink;
        setting.font = font;
        setting.isFooterHide = isFooterHide;
        setting.subTitle = subTitle;
        setting.arrowType = arrowType;
        setting.arrowSize = arrowSize;
        setting.fonts = fontsList;
        setting.displayServices = displayServices;

        saveIntegration({ PageSettings: setting });
    };

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setAvatarLink(image.src);
        setSetting({
            ...setting,
            name: image.caption,
        });
    };
    const SetClose = () => {
        setEditMode({
            'title': false,
            'subTitle': false,
            'arrow': false,
            'primaryColor': false,
            'buttonColor': false,
            'redeemBar': false,
            'redeemButton': false,
            'buttonTextColor': false,
            'redeemTextColor': false,
            'shoppingBar': false,
            'shoppingBarText': false
        });
    };
    const CloseColorBox = (event) => {
        if ((iseditMode.title === true || iseditMode.arrow === true ||
            iseditMode.subTitle === true || iseditMode.primaryColor === true || iseditMode.buttonColor === true || iseditMode.redeemBar === true
            || iseditMode.redeemButton === true || iseditMode.buttonTextColor === true ||
            iseditMode.shoppingBar === true || iseditMode.shoppingBarText === true)) {
            SetClose();

        }
    };

    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={'avatar'}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    return (
        <Fragment>
            {setting ? (
                <Card>
                    <CardBody name="bodyClick" onClick={(e) => { CloseColorBox(e); }}>
                        <div className="text-center">
                            <h6>Standalone Guest Service Page Appearance</h6>
                            <Separator className="mb-3" />
                            <CardImg
                                top
                                src={avatarLink}
                                alt="Card image cap"
                                className="img-thumbnail border-0 rounded-circle list-thumbnail"
                            />
                            <div className="mb-1">
                                <Button
                                    color="success"
                                    size="xs"
                                    className="mt-1"
                                    onClick={togglegallery}
                                >
                                    Browse Logo
                                </Button>
                            </div>

                            <div className="my-2">
                                <b>Title</b>
                                <br />
                                <input
                                    name="title"
                                    style={InputStlye}
                                    defaultValue={setting.title}
                                    onChange={(e) => setAvatarName(e.target.value)}
                                />
                            </div>

                            <div className="mb-1">
                                <b>Subtitle</b>
                                <br />
                                <input
                                    name="subTitle"
                                    style={InputStlye}
                                    defaultValue={setting.subTitle}
                                    onChange={(e) => setSubTitle(e.target.value)}
                                />
                            </div>

                        </div>
                        <div className="text-left">
                            <div className="my-2 text-center"><b>Colour Settings</b></div>
                            <div style={{ padding: '0 5%' }}>

                                <Row>
                                    <Colxx xxs="6">
                                        <div>
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Button Text Color</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.buttonTextColor = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.buttonTextColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, buttonTextColor: !iseditMode.buttonTextColor });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.buttonTextColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.buttonTextColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.buttonTextColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.buttonTextColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Redeem Text Color</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.redeemTextColor = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.redeemTextColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, redeemTextColor: !iseditMode.redeemTextColor });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.redeemTextColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.redeemTextColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.redeemTextColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.redeemTextColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Title Text</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.title = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.title}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, title: !iseditMode.title });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.title)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.title && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.title}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.title = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>

                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Primary Color</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.primaryColor = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.primaryColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, primaryColor: !iseditMode.primaryColor });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.primaryColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.primaryColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.primaryColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.primaryColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Button Color</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.buttonColor = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.buttonColor}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, buttonColor: !iseditMode.buttonColor });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.buttonColor)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.buttonColor && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.buttonColor}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.buttonColor = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Redeem Bar</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.redeemBar = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.redeemBar}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, redeemBar: !iseditMode.redeemBar });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.redeemBar)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.redeemBar && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.redeemBar}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.redeemBar = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className='col-md-6 text-left' style={{
                                                    marginTop: '0.30rem'
                                                }}><span className=''>Redeem Button</span></div>
                                                <div className='col-md-6'>
                                                    <InputGroup>
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.redeemButton = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                            value={setting.colours.redeemButton}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, redeemButton: !iseditMode.redeemButton });
                                                            }
                                                            } className="color-square" style={setBackGroundColor(setting.colours.redeemButton)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.redeemButton && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-2'
                                                    style={{ width: '240px' }}
                                                    color={setting.colours.redeemButton}
                                                    onChangeComplete={(e) => {

                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.redeemButton = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div>
                                        </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div>
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className=' col-md-6' style={{
                                                    marginTop: '0.30rem'
                                                }}>Subtitle Text</div>
                                                < div className='col-md-6' >
                                                    <InputGroup className="">
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            value={setting.colours.subTitle}

                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.subTitle = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, subTitle: !iseditMode.subTitle });
                                                            }} className="color-square" style={setBackGroundColor(setting.colours.subTitle)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.subTitle &&
                                            <div className='parent-div'>
                                                <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                    <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                        color={setting.colours.subTitle}
                                                        name="subTitle"
                                                        onChange={(e) => {
                                                            if (edit) {
                                                                let colours = setting.colours;
                                                                colours.subTitle = e.hex;
                                                                setSetting({ ...setting, colours: colours });
                                                            } else setError(true);
                                                        }
                                                        }
                                                    />
                                                </div>
                                            </div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className=' col-md-6' style={{
                                                    marginTop: '0.30rem'
                                                }}>Shopping Bar</div>
                                                < div className='col-md-6' >
                                                    <InputGroup className="">
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            value={setting.colours.shoppingBar}

                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.shoppingBar = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, shoppingBar: !iseditMode.shoppingBar });
                                                            }} className="color-square" style={setBackGroundColor(setting.colours.shoppingBar)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.shoppingBar && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                    color={setting.colours.shoppingBar}
                                                    name="subTitle"
                                                    onChange={(e) => {
                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.shoppingBar = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div></div>}
                                    </Colxx>
                                    <Colxx xxs="6">
                                        <div >
                                            <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                <div className=' col-md-6' style={{
                                                    marginTop: '0.30rem'
                                                }}>Shopping Bar Text</div>
                                                < div className='col-md-6' >
                                                    <InputGroup className="">
                                                        <Input
                                                            className=""
                                                            type="text"
                                                            value={setting.colours.shoppingBarText}

                                                            onChange={(e) => {
                                                                let colours = setting.colours;
                                                                colours.shoppingBarText = e.target.value;
                                                                setSetting({ ...setting, colours: colours });
                                                            }}
                                                        />
                                                        <InputGroupAddon addonType="append">
                                                            <InputGroupText onClick={() => {
                                                                setEditMode({ ...iseditMode, shoppingBarText: !iseditMode.shoppingBarText });
                                                            }} className="color-square" style={setBackGroundColor(setting.colours.shoppingBarText)}></InputGroupText>
                                                        </InputGroupAddon>
                                                    </InputGroup>
                                                </div>
                                            </div>
                                        </div>
                                        {iseditMode.shoppingBarText && <div className='parent-div'>
                                            <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                <ChromePicker disableAlpha={true} className='ml-3 chrome-picker-extend' style={{ width: '180px' }}
                                                    color={setting.colours.shoppingBarText}
                                                    name="subTitle"
                                                    onChange={(e) => {
                                                        if (edit) {
                                                            let colours = setting.colours;
                                                            colours.shoppingBarText = e.hex;
                                                            setSetting({ ...setting, colours: colours });
                                                        } else setError(true);
                                                    }
                                                    }
                                                />
                                            </div></div>}
                                    </Colxx>


                                </Row>
                            </div>
                            <div className="my-3 text-center"><b>Arrow Type</b></div>
                            <div className="row d-flex justify-content-center mb-1 mx-2 ">

                                <div className=' text-left'>
                                    <div
                                        onClick={event => {
                                            setArrowType(1);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 1 ? "select" : "false"}`}
                                            aria-label="Next Item"
                                            tabIndex="0"
                                            data-hook="nav-arrow-next"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 24.725px)', right: '10px' }}
                                        >
                                            <svg
                                                className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.65)' }}
                                                width="28px"
                                                height="28px"
                                                viewBox="0 0 40 33"
                                                version="1.1"
                                                xmlns="http://www.w3.org/2000/svg"
                                                xmlns-xlink="http://www.w3.org/1999/xlink"
                                            >
                                                <g stroke="none" strokeWidth="1" fillRule="evenodd">
                                                    <g
                                                        transform="translate(-28.000000, -32.000000)"
                                                        strokeWidth="nonzero"
                                                    >
                                                        <polygon
                                                            transform="translate(47.800000, 48.469489) rotate(-180.000000) translate(-47.800000, -48.469489) "
                                                            points="43.2916087 32 44.4061622 33.1660321 30.8430707 47.6817192 67.6 47.6813756 67.6 49.2576026 30.9452714 49.2580761 44.4061622 63.772946 43.2924258 64.9389782 28.8681974 49.4277178 28 48.5197421"
                                                        ></polygon>
                                                    </g>
                                                </g>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                <div className=' text-left'>
                                    <div
                                        className={arrowType === 2 ? true : false}
                                        onClick={event => {
                                            setArrowType(2);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 2 ? "select" : "false"}`} aria-label="Next Item" tabIndex="0" data-hook="nav-arrow-next"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 6.80769px)', right: '28px' }}><svg className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.65)' }} width="28px" height="28px" viewBox="0 0 39 11" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" strokeWidth="1" fillRule="evenodd"><g transform="translate(-29.000000, -43.000000)"
                                                    fillRule="nonzero"><polygon points="59.79296 43 67.1767272 48.2074587 59.79296 53.3482492 59.792 49.24 29 49.2402303 29 47.3156703 59.792 47.315"></polygon></g></g></svg></button>
                                    </div>

                                </div>
                                <div className=' text-left'>
                                    <div
                                        className={arrowType === 3 ? true : false}
                                        onClick={event => {
                                            setArrowType(3);
                                        }}
                                    > <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 3 ? "select" : "false"}`}
                                        aria-label="Next Item" tabIndex="0" data-hook="nav-arrow-next"
                                        style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 52.94px)', right: '28px' }}>
                                            <svg className="slideshow-arrow" style={{ transform: 'scaleX(1) scale(1.64)' }} width="28px" height="28px" viewBox="0 0 25 42"
                                                version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns-xlink="http://www.w3.org/1999/xlink"><g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd"><g id="Artboard-Copy-97" transform="translate(-36.000000, -27.000000)" fillRule="nonzero"><path d="M37.2206398,28.239114 C38.8026583,26.647265 41.3436172,26.5881667 42.9967317,28.0675785 L43.1590153,28.2206482 L59.1611748,44.1233571 C61.1319602,46.0819718 61.1995454,49.2312919 59.3527322,51.2754674 L59.1795659,51.4581932 L43.1590166,67.3793505 C41.51408,69.0140701 38.8553922,69.0057967 37.2206146,67.3608606 C35.638653,65.7689547 35.5953873,63.2276769 37.0850712,61.5838107 L37.2391492,61.4224839 L50.946,47.799 L37.2391492,34.1775161 C35.7003375,32.6482622 35.5938031,30.2229032 36.9247365,28.5696317 L37.0675472,28.4014262 L37.2206398,28.239114 Z" id="8"></path></g></g></svg></button>
                                    </div>
                                </div>
                                <div className=' text-left'>
                                    <div
                                        className={arrowType === 4 ? true : false}
                                        onClick={event => {
                                            setArrowType(4);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 4 ? "select" : "false"}`} aria-label="Previous Item" tabIndex="0" data-hook="nav-arrow-back"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 18.6538px)', right: '28px' }}><svg className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.69231)' }} width="28px" height="28px" viewBox="0 0 39 25" version="1.1" xmlns="http://www.w3.org/2000/svg"
                                                xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" strokeWidth="1" fillRule="evenodd"><g transform="translate(-29.000000, -36.000000)"
                                                    fillRule="nonzero"><path d="M29,48.2400242 C29,47.3087892 29.6817196,46.6578788 30.6657131,46.6578788 L62.0721815,46.6578788 L53.6034603,38.6027842 C52.9919732,38.0244263 52.9745394,37.0965804 53.5626533,36.4993057 L53.6196503,36.4424086 C54.2232252,35.8695838 55.2162345,35.8487051 55.8566495,36.4049822 L66.7354947,46.6987178 C66.8997789,46.8532785 67.0362567,47.0299812 67.1410943,47.2233734 C67.6421069,47.9137524 67.5952684,48.7577348 67.0654839,49.3382112 L66.9183084,49.529704 C66.8745903,49.5829565 66.834409,49.6278886 66.7923536,49.6712745 L55.84922,60.0371144 C55.2232594,60.6516206 54.1974244,60.6696143 53.554893,60.0838114 C52.9168128,59.5020667 52.8980482,58.5443858 53.5126939,57.940867 L53.5761731,57.877497 L62.0800244,49.8549119 L30.6657131,49.8549119 C29.6912419,49.8549119 29,49.1805348 29,48.2400242 Z" id="5"></path></g></g></svg></button>
                                    </div>
                                </div>
                                <div className=' text-left'>
                                    <div
                                        className={arrowType === 5 ? true : false}
                                        onClick={event => {
                                            setArrowType(5);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 5 ? "select" : "false"}`} aria-label="Next Item" tabIndex="0" data-hook="nav-arrow-next" style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 6.9875px)', left: '28px' }}><svg className="slideshow-arrow" style={{ transform: 'scaleX(1) scale(0.575)' }} width="28px" height="28px" viewBox="0 0 40 33" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" strokeWidth="1" fillRule="evenodd"><g transform="translate(-28.000000, -32.000000)" strokeWidth="nonzero"><polygon transform="translate(47.800000, 48.469489) rotate(-180.000000) translate(-47.800000, -48.469489) " points="43.2916087 32 44.4061622 33.1660321 30.8430707 47.6817192 67.6 47.6813756 67.6 49.2576026 30.9452714 49.2580761 44.4061622 63.772946 43.2924258 64.9389782 28.8681974 49.4277178 28 48.5197421"></polygon></g></g></svg></button>
                                    </div>
                                </div>
                                <div className='text-left'>
                                    <div
                                        className={arrowType === 6 ? true : false}
                                        onClick={event => {
                                            setArrowType(6);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 6 ? "select" : "false"}`} aria-label="Next Item" tabIndex="0" data-hook="nav-arrow-next"
                                            style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 24.725px)', right: '28px' }}><svg className="slideshow-arrow"
                                                style={{ transform: 'scaleX(1) scale(1.65)' }} width="28px" height="28px" viewBox="0 0 26 40" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns-xlink="http://www.w3.org/1999/xlink"><g stroke="none" strokeWidth="1" fillRule="evenodd">
                                                    <g transform="translate(-35.000000, -28.000000)" fillRule="nonzero"><polygon
                                                        points="60.4571429 47.8 40.6571429 67.6 35 61.9428571 49.1433951 47.7994621 35 33.6571429 40.6571429 28"></polygon></g></g></svg>
                                        </button>
                                    </div>
                                </div>
                                <div className=' text-left'>
                                    <div
                                        className={arrowType === 0 ? true : false}
                                        onClick={event => {
                                            setArrowType(0);
                                        }}
                                    >
                                        <button className={`mx-1 nav-arrows-container border-arrow  drop-shadow ${arrowType === 0 ? "select" : "false"}`} aria-label="Next Item" tabIndex="0" data-hook="nav-arrow-next" style={{ width: '28px', height: '28px', padding: '0px', top: 'calc(50% - 17px)', right: '28px' }}><svg className="slideshow-arrow" style={{ transform: 'scaleX(1) scale(1)' }} width="28" height="28" viewBox="0 0 23 39"><path d="M857.005,231.479L858.5,230l18.124,18-18.127,18-1.49-1.48L873.638,248Z" transform="translate(-855 -230)"></path></svg></button>
                                    </div>
                                </div>
                            </div>
                            <Row>
                                <Colxx xxs="6">
                                    <div className="my-2 mt-3 text-center"><b>Arrow Size</b></div>

                                    <div className="mb-1 text-center">
                                        <b>Size</b>
                                        <br />
                                        <div className='d-flex justify-content-center'>
                                            <input defaultValue={setting.arrowSize} style={InputStlye} type='range' value={arrowSize} min='0' max='200' onChange={e => setArrowSize(e.target.value)}></input> <span className='ml-3 arrowSize'>{arrowSize} </span></div>
                                    </div>
                                </Colxx>
                                <Colxx xxs="6">
                                    <div className="my-2 mt-3 text-center"><b> Display Services</b></div>
                                    <div className='d-flex justify-content-center'>
                                        <Input defaultValue={setting.displayServices} style={InputStlye} type='select'
                                            value={displayServices} min='0' max='200' onChange={e => setDisplayServices(e.target.value)}>
                                            <option value="0">Random Rotation</option>
                                            <option value="1">As Per Service Order Defined</option>
                                        </Input>
                                    </div>
                                </Colxx>
                            </Row>
                            <Row>
                                <Colxx xxs="6">
                                    <div className="my-2 mt-3 text-center"><b>Arrow Color</b></div>
                                    <div style={{ padding: '0 5%' }}>
                                        <Row>

                                            <Colxx xxs="12">
                                                <div >
                                                    <div className='row mb-2' onClick={(e) => { e.stopPropagation(); }}>
                                                        <div className='col-md-3'></div>
                                                        <div className='col-md-6'>
                                                            <InputGroup>
                                                                <Input
                                                                    className=""
                                                                    type="text"
                                                                    onChange={(e) => {
                                                                        let colours = setting.colours;
                                                                        colours.arrow = e.target.value;
                                                                        setSetting({ ...setting, colours: colours });
                                                                    }}
                                                                    value={setting.colours.arrow}
                                                                />
                                                                <InputGroupAddon addonType="append">
                                                                    <InputGroupText onClick={() => {
                                                                        setEditMode({ ...iseditMode, arrow: !iseditMode.arrow });
                                                                    }
                                                                    } className="color-square" style={setBackGroundColor(setting.colours.arrow)}></InputGroupText>
                                                                </InputGroupAddon>
                                                            </InputGroup>
                                                        </div>
                                                    </div>
                                                </div>
                                                {iseditMode.arrow && <div className='parent-div d-flex justify-content-center'>
                                                    <div className='cover' onClick={(e) => { e.stopPropagation(); }}>
                                                        <ChromePicker disableAlpha={true} className='ml-2'
                                                            style={{ width: '240px' }}
                                                            color={setting.colours.arrow}
                                                            onChangeComplete={(e) => {

                                                                if (edit) {
                                                                    let colours = setting.colours;
                                                                    colours.arrow = e.hex;
                                                                    setSetting({ ...setting, colours: colours });
                                                                } else setError(true);
                                                            }
                                                            }
                                                        />
                                                    </div>
                                                </div>}
                                            </Colxx>

                                        </Row>
                                    </div>
                                </Colxx>
                                <Colxx xxs="6">
                                    <div className="my-2 mt-3 text-center"><b>Scroll Direction</b></div>
                                    <div style={{ padding: '0 5%' }}>
                                        <Row>
                                            <Colxx xxs="6" className='text-right'>
                                                <CustomInput
                                                    key="Horizontal"
                                                    type="radio"
                                                    id="Horizontal"
                                                    value={setting.scrollDirection}
                                                    label="Horizontal"
                                                    onChange={(e) => {
                                                        setSetting({ ...setting, scrollDirection: 1 });
                                                    }}
                                                    checked={
                                                        setting.scrollDirection === 1 ? true : false
                                                    }
                                                />
                                            </Colxx>

                                            <Colxx xxs="6">
                                                <CustomInput
                                                    key="Vertical"
                                                    type="radio"
                                                    id="Vertical"
                                                    label="Vertical"
                                                    value={setting.scrollDirection}
                                                    onChange={(e) => {
                                                        setSetting({ ...setting, scrollDirection: 0 });
                                                    }}
                                                    checked={
                                                        setting.scrollDirection === 0 ? true : false
                                                    }
                                                />
                                            </Colxx>
                                        </Row>
                                    </div>
                                </Colxx>
                            </Row>

                            <div className="my-2 mt-3 text-center"><b>Font Settings</b></div>
                            <div className='row'>
                                <div className="col-md-6">
                                    <div className="mb-1  row">
                                        <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                            <b>Website Font Name </b>
                                        </div>
                                        <br />
                                        <div className="col-md-6">
                                            <FontsList InputStlye={SelectStyle} value={setting.font} settings={setting} setFont={(e) => setFont(e.target.value)}></FontsList>
                                        </div>
                                    </div>
                                </div>
                                {setting.fonts !== undefined &&
                                    <Fragment>
                                        <div className="col-md-6">
                                            <div className="mb-1  row">
                                                <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                    <b>Title Font </b>
                                                </div>
                                                <br />
                                                <div className="col-md-6">
                                                    <FontsList InputStlye={SelectStyle} value={setting.fonts.title} settings={setting} setFont={(e) => setFontsList({ ...fontsList, title: e.target.value })}></FontsList>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                    <b>Subtitle Font </b>
                                                </div>
                                                <br />
                                                <div className="col-md-6">
                                                    <FontsList InputStlye={SelectStyle} value={setting.fonts.subTitle} settings={setting} setFont={(e) => setFontsList({ ...fontsList, subTitle: e.target.value })}></FontsList>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                    <b>Button Font </b>
                                                </div>
                                                <br />
                                                <div className="col-md-6">
                                                    <FontsList InputStlye={SelectStyle} value={setting.fonts.buttonText} settings={setting} setFont={(e) => setFontsList({ ...fontsList, buttonText: e.target.value })}></FontsList>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                    <b>Service Title Font </b>
                                                </div>
                                                <br />
                                                <div className="col-md-6">
                                                    <FontsList InputStlye={SelectStyle} value={setting.fonts.serviceTitle} settings={setting} setFont={(e) => setFontsList({ ...fontsList, serviceTitle: e.target.value })}></FontsList>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="mb-1 row">
                                                <div className="col-md-6 text-left" style={{ marginTop: '1.05rem' }}>
                                                    <b>Service Description Font </b>
                                                </div>
                                                <br />
                                                <div className="col-md-6">
                                                    <FontsList InputStlye={SelectStyle} value={setting.fonts.serviceDescription} settings={setting} setFont={(e) => setFontsList({ ...fontsList, serviceDescription: e.target.value })}></FontsList>
                                                </div>
                                            </div>
                                        </div>
                                    </Fragment>
                                }
                            </div>
                            <div className='d-flex justify-content-center my-3'>
                                <CustomInput
                                    key="isFooterBmb"
                                    type="checkbox"
                                    checked={isFooterHide}
                                    onChange={(e) => e.target.checked === true ? setIsFooterHide(true) : setIsFooterHide(false)}
                                ><span>Hide "Powered by bmb"</span></CustomInput>
                            </div>
                            <div className='d-flex justify-content-center my-3'>
                                <Button
                                    size="xs"
                                    color="dark"
                                    outline
                                    onClick={() => {
                                        handleColoursReset();
                                    }}
                                >
                                    Reset to default font and colors
                                </Button>
                            </div>
                            <div className='text-center'>
                                <ButtonGroup className="mb-2 " style={{ marginTop: '40px' }}>
                                    <Button color="primary" size="xs" onClick={handleSave}>
                                        Save
                                    </Button>
                                    <Button
                                        size="xs"
                                        color="dark"

                                        onClick={() => {
                                            CloseColorBox();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </div>
                    </CardBody>
                </Card >
            ) : null
            }
            {ImageGalleryButton()}

        </Fragment >
    );
}

